// Edition-dependent route wrappers for App.tsx (PLAN.md §5.1, owner A). Agencies always get the page exactly as
// before; only a company the server calls a hotel is affected.
import type { ReactNode } from "react";
import { Redirect } from "wouter";
import { useEdition } from "@/lib/edition";
import { SidebarLayout } from "@/components/SidebarLayout";

/** Extra module a hotel sees locked in the menu (Mike A3): a direct visit sends the hotel to "/". While the
 *  capability loads: a spinner, never the page. On a load error: fail closed to "/" like EditionModuleGate
 *  (PLAN §2 neutral view, review he-a F3); only a ready agency capability renders the page. */
export function HotelLockedRoute({ children }: { children: ReactNode }) {
  const state = useEdition();
  if (state.status === "loading") {
    return (
      <div className="min-h-[50vh] flex items-center justify-center" data-testid="edition-route-loading">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (state.status !== "ready" || state.edition.kind === "hotel") return <Redirect to="/" />;
  return <>{children}</>;
}

/** Full-screen page that hotels see inside the normal sidebar layout (PlatformConnections, PLAN §5.1 item 5). */
export function HotelSidebarLayout({ children }: { children: ReactNode }) {
  const state = useEdition();
  if (state.status === "ready" && state.edition.kind === "hotel") return <SidebarLayout>{children}</SidebarLayout>;
  return <>{children}</>;
}
